import React from "react"
import PropTypes from "prop-types"
import SelectField from "../OpportunitySearchFilter/wrappers/SelectField"
import CompanyAutocomplete from "./wrappers/CompanyAutocomplete"
import LocationField from "./wrappers/LocationField"
import CheckboxGroup from "../../CheckboxGroup"
import { filterOptions } from "./filterConfig"
import { setValue } from "./useReducer/actionCreators"
import styles from "./index.module.scss"

const AdvancedFilters = ({ values, dispatch }) => {
  const set = (name) => (value) => dispatch(setValue(name, value))
  // Two columns: the company based and single choice filters, then the two checkbox lists.
  return (
    <div className={styles.advancedGrid}>
      <div className={styles.column}>
        <div className={styles.item}>
          <CheckboxGroup
            id="filter_sector"
            label="Sector"
            options={filterOptions.sector}
            values={values.sector}
            onChange={set("sector")}
            collapseAfter={null}
          />
        </div>
        <div className={styles.item}>
          <SelectField
            id="filter_industry"
            label="Industry"
            options={filterOptions.industry}
            value={values.industry}
            onChange={set("industry")}
          />
        </div>
        <div className={styles.item}>
          <CompanyAutocomplete
            companyInput={values.companyInput}
            externalDispatch={dispatch}
          />
        </div>
        <div className={styles.item}>
          <SelectField
            id="filter_event_type"
            label="Event Type"
            options={filterOptions.eventType}
            value={values.eventType}
            onChange={set("eventType")}
          />
        </div>
        <div className={styles.item}>
          <LocationField value={values.location} onChange={set("location")} />
        </div>
        <div className={styles.item}>
          <SelectField
            id="filter_cost"
            label="Cost"
            options={filterOptions.cost}
            value={values.cost}
            onChange={set("cost")}
          />
        </div>
      </div>
      <div className={styles.column}>
        <div className={styles.item}>
          <CheckboxGroup
            id="filter_content_purpose"
            label="Content Purpose"
            options={filterOptions.contentPurpose}
            values={values.contentPurpose}
            onChange={set("contentPurpose")}
            collapseAfter={null}
          />
        </div>
        <div className={styles.item}>
          <CheckboxGroup
            id="filter_resource_features"
            label="Resource Features"
            options={filterOptions.resourceFeatures}
            values={values.resourceFeatures}
            onChange={set("resourceFeatures")}
            collapseAfter={null}
            scrollAfter={null}
          />
        </div>
      </div>
    </div>
  )
}

AdvancedFilters.propTypes = {
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}

export default AdvancedFilters
